{
    "webshop_offer_voucher_correctCode": "Du angav en giltig kod",
    "webShop_howToFindId_desc": "Du kan hitta och kopiera ditt personliga ID i din spelarprofil.",
    "webShop_howToFindId_link": "Var hittar jag mitt personliga ID?",
    "webshop_offer_voucher_codeIsIncorrect": "Koden är felaktig",
    "webshop_offer_voucher_enterYourCode": "Ange ditt personliga ID",
    "webShop_unexpectedError_desc": "Ett oväntat fel har inträffat. Försök igen senare.",
    "webShop_accountBanned_desc": "Konto avstängt!",
    "webshop_confirm": "OK",
    "webshop_termsConditions_1": "Villkor och krav",
    "webshop_purchase_privacyPolicy": "Integritetspolicy",
    "webshop_legal_1": "Juridiskt",
    "webshop_support_1": "Kontakta supporten",
    "mbs_access_welcome_desc": "Välkommen, {0}",
    "btn_login": "Logga in",
    "mbs_access_error_sessionExpired_desc": "Din session har gått ut. Ange ditt konto-ID manuellt."
}
